import { useState } from 'react';
import { Button } from 'react-bootstrap';
import {
    ProjectsTable,
    Pagination,
    FilterProjectsOffcanvas,
    AddProjectModal,
    DeleteProjectModal,
    ViewHistoryOffcanvas,
    ContactDetailsModal
} from './components';

const MyProjects = () => {
    const [show, setShow] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [showHistory, setShowHistory] = useState(false);
    const [showContact, setShowContact] = useState(false);
    const [selectedContact, setSelectedContact] = useState(null);
    const [historyList, setHistoryList] = useState([]);

    // Filter states
    const [clientFilter, setClientFilter] = useState(null);
    const [projectFilter, setProjectFilter] = useState(null);
    const [assigneeFilter, setAssigneeFilter] = useState([]);
    const [dueDateRange, setDueDateRange] = useState([null, null]);
    const [budgetRange, setBudgetRange] = useState([null, null]);
    const [paymentFilter, setPaymentFilter] = useState(null);
    const [stageFilter, setStageFilter] = useState(null);

    // Add Project Modal states
    const [selectedClient, setSelectedClient] = useState(null);
    const [projectName, setProjectName] = useState('');
    const [startDate, setStartDate] = useState(null);
    const [dueDate, setDueDate] = useState(null);
    const [estimatedBudget, setEstimatedBudget] = useState('');
    const [estimatedTime, setEstimatedTime] = useState('');
    const [selectedPriority, setSelectedPriority] = useState(null);
    const [selectedAssignees, setSelectedAssignees] = useState([]);
    const [description, setDescription] = useState('');
    const [profitMargin, setProfitMargin] = useState('');
    const [targetProfit, setTargetProfit] = useState('');
    const [targetCosts, setTargetCosts] = useState('');
    const [financialProposal, setFinancialProposal] = useState(null);

    // Options
    const clientOptions = [
        { value: 'client1', label: 'Client 1' },
        { value: 'client2', label: 'Client 2' },
        { value: 'client3', label: 'Client 3' },
    ];

    const projectOptions = [
        { value: 'project1', label: 'Project 1' },
        { value: 'project2', label: 'Project 2' },
        { value: 'project3', label: 'Project 3' },
    ];

    const assigneeOptions = [
        { value: 'user1', label: 'John Doe' },
        { value: 'user2', label: 'Jane Smith' },
        { value: 'user3', label: 'Bob Johnson' },
    ];

    const priorityOptions = [
        { value: 'high', label: 'High' },
        { value: 'medium', label: 'Medium' },
        { value: 'low', label: 'Low' },
    ];

    const paymentOptions = [
        { value: 'paid', label: 'Paid' },
        { value: 'pending', label: 'Pending' },
        { value: 'unpaid', label: 'Unpaid' },
    ];

    const stageOptions = [
        { value: 'planning', label: 'Planning' },
        { value: 'inProgress', label: 'In Progress' },
        { value: 'review', label: 'Review' },
        { value: 'completed', label: 'Completed' },
    ];

    // Handler functions
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);
    const handleMoveOrCopyShow = () => {
        // TODO: Implement move/copy functionality
        console.log('Move/Copy show');
    };
    const handleLogTimeShow = (data) => {
        // TODO: Implement log time functionality
        console.log('Log time:', data);
    };
    const handleHistoryShow = () => {
        setShowHistory(true);
        // Mock history data
        setHistoryList([
            {
                date: '2025-08-13',
                time: '14:30',
                user: 'John Doe',
                action: 'Updated project status to "In Progress"',
                type: 'status'
            },
            {
                date: '2025-08-13',
                time: '13:45',
                user: 'Jane Smith',
                action: 'Added new task: Implement user authentication',
                type: 'task'
            },
            {
                date: '2025-08-13',
                time: '11:20',
                user: 'John Doe',
                action: 'Working on frontend development',
                type: 'time',
                duration: '3 Hours 30 Minutes'
            },
            {
                date: '2025-08-12',
                time: '16:15',
                user: 'Bob Johnson',
                action: 'Updated project budget from $20,000 to $25,000',
                type: 'budget'
            },
            {
                date: '2025-08-12',
                time: '14:00',
                user: 'Jane Smith',
                action: 'Backend development and API integration',
                type: 'time',
                duration: '4 Hours 15 Minutes'
            },
            {
                date: '2025-08-12',
                time: '10:30',
                user: 'Sarah Wilson',
                action: 'Added new team member: Mike Thompson',
                type: 'team'
            },
            {
                date: '2025-08-11',
                time: '15:45',
                user: 'Mike Thompson',
                action: 'Database optimization and testing',
                type: 'time',
                duration: '2 Hours 45 Minutes'
            },
            {
                date: '2025-08-11',
                time: '13:20',
                user: 'John Doe',
                action: 'Updated project deadline to August 30, 2025',
                type: 'deadline'
            },
            {
                date: '2025-08-11',
                time: '11:00',
                user: 'Bob Johnson',
                action: 'Client meeting and requirement gathering',
                type: 'time',
                duration: '1 Hour 30 Minutes'
            },
            {
                date: '2025-08-11',
                time: '09:15',
                user: 'Jane Smith',
                action: 'Created project and initial setup',
                type: 'project'
            }
        ]);
    };
    const handleHistoryClose = () => {
        setShowHistory(false);
    };
    const handleQuickSubtasksShow = () => {
        // TODO: Implement quick subtasks
        console.log('Show quick subtasks');
    };
    const handleDeleteShow = () => {
        setShowDelete(true);
    };
    const handleDeleteClose = () => {
        setShowDelete(false);
    };
    const handleDelete = () => {
        // TODO: Implement delete functionality
        console.log('Deleting project');
        handleDeleteClose();
    };
    const handleEstimateTimeShow = () => {
        // TODO: Implement time estimation
        console.log('Show time estimation');
    };

    const handleContactShow = (contact) => {
        setSelectedContact(contact);
        setShowContact(true);
    };

    const handleContactClose = () => {
        setShowContact(false);
        setSelectedContact(null);
    };

    const [pageSize, setPageSize] = useState(20);
    const [currentPage, setCurrentPage] = useState(1);
    const totalItems = 100; // This would come from your API
    const totalPages = Math.ceil(totalItems / pageSize);

    return (
        <>
            <div className='c-card-1'>
                <div className='c-card-header-1'>
                    <div className='d-flex justify-content-between align-items-center w-100'>
                        <div>
                            Projects Management
                        </div>
                        <div className='d-flex align-items-center gap-1'>
                            <Button variant='outline-primary' 
                                className='btn-sm me-2 text-nowrap'
                                onClick={() => setShowFilter(true)}
                            >
                                <i className="fas fa-filter me-1"></i>
                                Filter
                            </Button>
                            <Button variant='primary'
                                className='btn-sm text-nowrap'
                                onClick={handleShow}
                            >
                                <i className="fas fa-plus me-1"></i>
                                Add Project
                            </Button>
                        </div>
                    </div>
                </div>
                <div className='c-card-body-1 p-0'>
                    <ProjectsTable
                        onEdit={handleShow}
                        onMoveOrCopy={handleMoveOrCopyShow}
                        onLogTime={handleLogTimeShow}
                        onViewHistory={handleHistoryShow}
                        onAddSubtasks={handleQuickSubtasksShow}
                        onView={() => {}} // TODO: Implement view handler
                        onDuplicate={() => {}} // TODO: Implement duplicate handler
                        onDelete={handleDeleteShow}
                        onEstimateTime={handleEstimateTimeShow}
                        onContactClick={handleContactShow}
                    />
                </div>
                <div className='c-card-footer-1'>
                    <Pagination
                        pageSize={pageSize}
                        onPageSizeChange={setPageSize}
                        currentPage={currentPage}
                        onPageChange={setCurrentPage}
                        totalPages={totalPages}
                        totalItems={totalItems}
                    />
                </div>
            </div>

            <FilterProjectsOffcanvas
                show={showFilter}
                onHide={() => setShowFilter(false)}
                clientFilter={clientFilter}
                setClientFilter={setClientFilter}
                projectFilter={projectFilter}
                setProjectFilter={setProjectFilter}
                assigneeFilter={assigneeFilter}
                setAssigneeFilter={setAssigneeFilter}
                dueDateRange={dueDateRange}
                setDueDateRange={setDueDateRange}
                budgetRange={budgetRange}
                setBudgetRange={setBudgetRange}
                paymentFilter={paymentFilter}
                setPaymentFilter={setPaymentFilter}
                stageFilter={stageFilter}
                setStageFilter={setStageFilter}
                projectOptions={projectOptions}
                assigneeOptions={assigneeOptions}
                clientOptions={clientOptions}
                paymentOptions={paymentOptions}
                stageOptions={stageOptions}
            />

            <AddProjectModal
                show={show}
                onHide={handleClose}
                selectedClient={selectedClient}
                setSelectedClient={setSelectedClient}
                projectName={projectName}
                setProjectName={setProjectName}
                startDate={startDate}
                setStartDate={setStartDate}
                dueDate={dueDate}
                setDueDate={setDueDate}
                estimatedBudget={estimatedBudget}
                setEstimatedBudget={setEstimatedBudget}
                estimatedTime={estimatedTime}
                setEstimatedTime={setEstimatedTime}
                selectedPriority={selectedPriority}
                setSelectedPriority={setSelectedPriority}
                selectedAssignees={selectedAssignees}
                setSelectedAssignees={setSelectedAssignees}
                description={description}
                setDescription={setDescription}
                profitMargin={profitMargin}
                setProfitMargin={setProfitMargin}
                targetProfit={targetProfit}
                setTargetProfit={setTargetProfit}
                targetCosts={targetCosts}
                setTargetCosts={setTargetCosts}
                financialProposal={financialProposal}
                setFinancialProposal={setFinancialProposal}
                clientOptions={clientOptions}
                priorityOptions={priorityOptions}
                assigneeOptions={assigneeOptions}
            />

            <DeleteProjectModal
                show={showDelete}
                onHide={handleDeleteClose}
                onConfirm={handleDelete}
            />

            <ViewHistoryOffcanvas
                show={showHistory}
                onHide={handleHistoryClose}
                historyList={historyList}
            />

            <ContactDetailsModal
                show={showContact}
                onHide={handleContactClose}
                contact={selectedContact}
            />
        </>
    );
};export default MyProjects;